// Shared so the header row and data rows line up (same reason as
// negative-reviews/qaTable.ts).
export const HOME_FEED_TABLE_COLUMNS =
  "grid grid-cols-[130px_100px_minmax(150px,1fr)_minmax(130px,1fr)_minmax(220px,2fr)_70px_minmax(120px,1fr)_90px_60px] items-center gap-3";
